import type { Meta, StoryObj } from "@storybook/react";

import CalendarSyncStep from "@/ui/components/onboarding/CalendarSyncStep";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<typeof CalendarSyncStep> = {
  title: "Components/Onboarding/Calendar Sync",
  component: CalendarSyncStep,
  argTypes: {
    testID: { control: "text" },
  },
  args: {
    testID: "storybook-calendar-sync",
  },
  render: (props) => (
    <Box padding={20} width="100%">
      <CalendarSyncStep {...props} />
    </Box>
  ),
};

type Story = StoryObj<typeof CalendarSyncStep>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
